import React from 'react';
import { TestimonialLayout } from './testimonials/TestimonialLayout';
import { TestimonialHeader } from './testimonials/TestimonialHeader';
import { TestimonialMetric } from './testimonials/TestimonialMetric';
import { TestimonialQuote } from './testimonials/TestimonialQuote';
import { Target, Heart, Brain } from 'lucide-react';

const KOA_IMAGE_URL = "https://res.cloudinary.com/dzg3lv6fh/image/upload/v1734473152/Koa_sz9rrx.png";

export const KoaTestimonial: React.FC = () => {
  const metrics = [
    {
      icon: Target,
      label: "Personal Goals",
      value: "95%",
      detail: "19 of 20 goals achieved",
      color: "text-neon-green"
    },
    {
      icon: Heart,
      label: "Wellness Score",
      value: "88%",
      detail: "7 of 8 habits mastered",
      color: "text-neon-purple"
    },
    {
      icon: Brain,
      label: "Growth Index",
      value: "92%",
      detail: "23 of 25 skills developed",
      color: "text-yellow-400"
    }
  ];

  return (
    <TestimonialLayout>
      <div className="relative">
        {/* Hero Image with Error Handling */}
        <div className="relative h-[80vh] overflow-hidden">
          <div className="absolute inset-0">
            <img 
              src={KOA_IMAGE_URL}
              alt="Koa"
              className="w-full h-full object-cover object-top"
              onError={(e) => {
                const img = e.target as HTMLImageElement;
                img.onerror = null;
                img.src = '/fallback-image.png';
              }}
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/60 to-black" />
        </div>

        {/* Content overlay */}
        <div className="absolute bottom-0 left-0 right-0 p-12">
          <div className="max-w-7xl mx-auto">
            <div className="space-y-6 max-w-2xl">
              <TestimonialHeader 
                title="Meet Koa: A LifeTrack Success Story 🚀"
                subtitle="At 29, Koa has transformed their life through holistic wellness and mindful living with LIFETRACK. Based in Hawaii, they've created a perfect blend of work, wellness, and island life."
              />

              <div className="grid grid-cols-3 gap-4">
                {metrics.map((metric) => (
                  <TestimonialMetric key={metric.label} {...metric} />
                ))}
              </div>

              <TestimonialQuote 
                quote="LIFETRACK has helped me find harmony between modern productivity and island living. It's not just about tracking goals—it's about creating a life that flows naturally with your values and environment."
                author="Koa"
              />
            </div>
          </div>
        </div>
      </div>
    </TestimonialLayout>
  );
};